// shared/data/fetchPersonalInfo.js
import axios from '../config/axios';

/**
 * Fetch personal info and user types for the authenticated user.
 *
 * @param {string} token - Authorization bearer token
 * @returns {Promise<Object>} combined personal info and types
 */
export async function fetchPersonalInfo(token) {
  const [userRes, typesRes] = await Promise.all([
    axios.get('/me/personal', {
      headers: { Authorization: `Bearer ${token}` },
    }),
    axios.get('/usertypes', {
      headers: { Authorization: `Bearer ${token}` },
    }),
  ]);

  const personalInfo = {
    fname: userRes.data.fname,
    lname: userRes.data.lname,
    email: userRes.data.email,
    phone: userRes.data.phone,
    phone_country: userRes.data.phone_country,
    smsEnabled: userRes.data.smsEnabled ?? userRes.data.sms_enabled ?? false,
    profilePicture: userRes.data.profile_picture,
    allowedTypeIds: userRes.data.allowed_type_ids,
    allowedSubtypeIds: userRes.data.allowed_subtype_ids,
    types: typesRes.data,
    cacheBust: Date.now(),
  };

  return personalInfo;
}
